<template>
  <div class="div">
    <!-- <div class="title">数据初始化</div> -->
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="设备拆分" name="SplitTheData"></el-tab-pane>
      <el-tab-pane label="资产设备" name="propertyInit"></el-tab-pane>
      <el-tab-pane label="备品备件" name="fittingsInit"></el-tab-pane>
    </el-tabs>
    <div class="content">
      <SplitTheData
        ref="SplitTheData"
        v-if="activeName === 'SplitTheData'"
      ></SplitTheData>
      <fittingsInit
        ref="fittingsInit"
        v-if="activeName === 'fittingsInit'"
      ></fittingsInit>
      <propertyInit
        ref="propertyInit"
        v-if="activeName === 'propertyInit'"
      ></propertyInit>
    </div>
  </div>
</template>
<script>
import fittingsInit from "./fittingsInit/fittingsInit.vue";
import propertyInit from "./propertyInit/propertyInit.vue";
import SplitTheData from "./SplitTheData/SplitTheData.vue";
export default {
  data() {
    return {
      activeName: "SplitTheData",
    };
  },
  props: {},
  components: { fittingsInit, propertyInit, SplitTheData },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .el-tabs__header {
  margin: 0;
}
.content {
  height: calc(100% - 40px);
}
</style>
